import {
  accountantSearchColumns,
  accountSearchColumns,
  boPhanSearchColumns,
  chiPhiKhongHopLeSearchColumns,
  dotThanhToanSearchColumns,
  hopDongSearchColumns,
  hoaDonSearchColumns,
  khachHangSearchColumns,
  kheUocSearchColumns,
  lenhSanXuatSearchColumns,
  phiSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  vuViecSearchColumns
} from '@/constants';
import {
  AccountModel,
  BoPhan,
  ChiPhiKhongHopLeData,
  DoiTuong,
  DotThanhToan,
  HopDong,
  KheUoc,
  type LenhSanXuat,
  Phi,
  VatTu,
  VuViec
} from '@/types/schemas';
import { CellFieldV2 as CellField, SearchField } from '@/components/custom/erp';
import { calculatePs } from '../../../utils';
import { FormMode } from '@/types/form';

interface CurrencyInfo {
  ma_nt: string;
  uuid: string;
}

export const getDetailColumns = (
  formMode: FormMode,
  onCellValueChange: (rowUuid: string, field: string, newValue: any) => void,
  currencyInfo?: CurrencyInfo | null,
  exchangeRate?: number
) => {
  const baseColumns = [
    {
      field: 'ma_ngvkt',
      headerName: 'Mã nghiệp vụ',
      width: 120,
      renderCell: (params: { row: any }) => (
        <SearchField<any>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.KHAI_BAO_NGHIEP_VU_KE_TOAN}/`}
          searchColumns={accountantSearchColumns}
          dialogTitle='Danh mục nghiệp vụ'
          columnDisplay='ma_ngvkt'
          value={params.row.ma_ngvkt_data?.ma_ngvkt || ''}
          onRowSelection={row => {
            onCellValueChange(params.row.uuid, 'ma_ngvkt_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_ngvkt',
        resultField: 'ma_ngvkt_data',
        detailEndpoint: QUERY_KEYS.KHAI_BAO_NGHIEP_VU_KE_TOAN
      }
    },
    {
      field: 'ten_ngvkt',
      headerName: 'Tên nghiệp vụ',
      width: 200,
      renderCell: (params: { row: any }) => (
        <CellField
          name='ten_ngvkt'
          type='text'
          value={params.row.ma_ngvkt_data?.ten_ngvkt}
          disabled={formMode === 'view'}
        />
      ),
      nonWritable: true
    },
    {
      field: 'tk_no',
      headerName: 'Tài khoản nợ',
      width: 200,
      renderCell: (params: { row: any }) => (
        <SearchField<AccountModel>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          columnDisplay='code'
          value={params.row.tk_no_data?.code || params.row.ma_ngvkt_data?.tk_no_data?.code || ''}
          onRowSelection={(row: AccountModel) => {
            onCellValueChange(params.row.uuid, 'tk_no_data', row);
          }}
          className='w-full'
          disabled={formMode === 'view'}
        />
      ),
      pasteConfig: {
        lookupKey: 'tk_no',
        resultField: 'tk_no_data',
        detailEndpoint: QUERY_KEYS.TAI_KHOAN
      }
    },
    {
      field: 'tk_co',
      headerName: 'Tài khoản có',
      width: 200,
      renderCell: (params: { row: any }) => (
        <SearchField<AccountModel>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          columnDisplay='code'
          value={params.row.tk_co_data?.code || params.row.ma_ngvkt_data?.tk_co_data?.code || ''}
          onRowSelection={(row: AccountModel) => {
            onCellValueChange(params.row.uuid, 'tk_co_data', row);
          }}
          className='w-full'
          disabled={formMode === 'view'}
        />
      ),
      pasteConfig: {
        lookupKey: 'tk_co',
        resultField: 'tk_co_data',
        detailEndpoint: QUERY_KEYS.TAI_KHOAN
      }
    },
    {
      field: 'ma_kh',
      headerName: 'Mã khách nợ',
      width: 200,
      renderCell: (params: { row: any }) => (
        <SearchField<DoiTuong>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          dialogTitle='Danh mục đối tượng'
          columnDisplay='customer_code'
          value={params.row.ma_kh_data?.customer_code}
          onRowSelection={(row: DoiTuong) => {
            onCellValueChange(params.row.uuid, 'ma_kh_data', row);
          }}
          className='w-full'
          disabled={formMode === 'view'}
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_kh',
        resultField: 'ma_kh_data',
        detailEndpoint: QUERY_KEYS.KHACH_HANG
      }
    },
    {
      field: 'ten_kh',
      headerName: 'Tên khách hàng',
      width: 200,
      renderCell: (params: { row: any }) => (
        <CellField name='ten_kh' type='text' value={params.row.ma_kh_data?.customer_name} />
      ),
      nonWritable: true
    },
    {
      field: 'ma_kh_co',
      headerName: 'Mã khách có',
      width: 200,
      renderCell: (params: { row: any }) => (
        <SearchField<DoiTuong>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          dialogTitle='Danh mục đối tượng'
          columnDisplay='customer_code'
          value={params.row.ma_kh_co_data?.customer_code}
          onRowSelection={(row: DoiTuong) => {
            onCellValueChange(params.row.uuid, 'ma_kh_co_data', row);
          }}
          className='w-full'
          disabled={formMode === 'view'}
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_kh_co',
        resultField: 'ma_kh_co_data',
        detailEndpoint: QUERY_KEYS.KHACH_HANG
      }
    },
    {
      field: 'ps_nt',
      headerName: currencyInfo?.ma_nt && currencyInfo.ma_nt !== 'VND' ? `Tiền ${currencyInfo.ma_nt}` : 'Tiền VND',
      width: 200,
      renderCell: (params: { row: any }) => (
        <CellField
          name='ps_nt'
          type='number'
          value={params.row.ps_nt}
          onValueChange={(newValue: any) => {
            onCellValueChange(params.row.uuid, 'ps_nt', newValue);
          }}
          disabled={formMode === 'view'}
        />
      )
    },
    {
      field: 'dien_giai',
      headerName: 'Diễn giải',
      width: 250,
      renderCell: (params: { row: any }) => (
        <CellField
          name='dien_giai'
          type='text'
          value={params.row.dien_giai}
          onValueChange={(newValue: any) => onCellValueChange(params.row.uuid, 'dien_giai', newValue)}
          disabled={formMode === 'view'}
        />
      )
    },
    {
      field: 'id_tt',
      headerName: 'Hóa đơn',
      width: 190,
      renderCell: (params: { row: any }) => (
        <SearchField<Record<string, unknown>>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.HOA_DON_THEO_KHACH_HANG}/?ma_kh=${params.row.ma_kh_data?.uuid}&document_type=PHIEU_KE_TOAN_THEO_NGHIEP_VU`}
          searchColumns={hoaDonSearchColumns}
          dialogTitle='Danh mục hóa đơn'
          columnDisplay='so_ct'
          value={params.row.id_tt_data?.so_ct || ''}
          onRowSelection={(row: Record<string, unknown>) => {
            onCellValueChange(params.row.uuid, 'id_tt_data', row);
          }}
          className='w-full'
          disabled={!params.row.ma_kh_data?.uuid || formMode === 'view'}
        />
      )
    },
    {
      field: 'so_ct0',
      headerName: 'Số hoá đơn',
      width: 100,
      renderCell: (params: { row: any }) => (
        <CellField
          name='so_ct0'
          type='text'
          value={params.row.so_ct0}
          onValueChange={(newValue: any) => onCellValueChange(params.row.uuid, 'so_ct0', newValue)}
          disabled={formMode === 'view'}
        />
      )
    },
    {
      field: 'ngay_ct0',
      headerName: 'Ngày hoá đơn',
      width: 200,
      renderCell: (params: { row: any }) => (
        <CellField
          name='ngay_ct0'
          type='date'
          value={params.row.ngay_ct0}
          onValueChange={(newValue: any) => onCellValueChange(params.row.uuid, 'ngay_ct0', newValue)}
          disabled={formMode === 'view'}
        />
      )
    },
    // Conditionally add ps column for non-VND currencies
    ...(currencyInfo?.ma_nt && currencyInfo.ma_nt !== 'VND'
      ? [
          {
            field: 'ps',
            headerName: 'Tiền',
            width: 200,
            renderCell: (params: { row: any }) => (
              <CellField
                name='ps'
                type='number'
                value={calculatePs(params.row.ps_nt || 0, exchangeRate || 1)}
                disabled={true}
              />
            )
          }
        ]
      : []),
    {
      field: 'ma_bp',
      headerName: 'Bộ phận',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<BoPhan>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.BO_PHAN}/`}
          searchColumns={boPhanSearchColumns}
          dialogTitle='Danh mục bộ phận'
          columnDisplay='ma_bp'
          displayRelatedField='ten_bp'
          value={params.row.ma_bp_data?.ma_bp || ''}
          onRowSelection={(row: BoPhan) => {
            onCellValueChange(params.row.uuid, 'ma_bp_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_bp',
        resultField: 'ma_bp_data',
        detailEndpoint: QUERY_KEYS.BO_PHAN
      }
    },
    {
      field: 'ma_vv',
      headerName: 'Vụ việc',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<VuViec>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.VU_VIEC}`}
          searchColumns={vuViecSearchColumns}
          dialogTitle='Danh mục vụ việc'
          columnDisplay='ma_vu_viec'
          displayRelatedField='ten_vu_viec'
          value={params.row.ma_vv_data?.ma_vu_viec || ''}
          onRowSelection={(row: VuViec) => {
            onCellValueChange(params.row.uuid, 'ma_vv_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_vv',
        resultField: 'ma_vv_data',
        detailEndpoint: QUERY_KEYS.VU_VIEC
      }
    },
    {
      field: 'ma_hd',
      headerName: 'Mã hợp đồng',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<HopDong>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.HOP_DONG}/`}
          searchColumns={hopDongSearchColumns}
          dialogTitle='Danh mục hợp đồng'
          columnDisplay='ma_hd'
          displayRelatedField='ten_hd'
          value={params.row.ma_hd_data?.ma_hd || ''}
          onRowSelection={(row: HopDong) => {
            onCellValueChange(params.row.uuid, 'ma_hd_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_hd',
        resultField: 'ma_hd_data',
        detailEndpoint: QUERY_KEYS.HOP_DONG
      }
    },
    {
      field: 'ma_dtt',
      headerName: 'Đợt thanh toán',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<DotThanhToan>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.DOT_THANH_TOAN}/`}
          searchColumns={dotThanhToanSearchColumns}
          dialogTitle='Danh mục đợt thanh toán'
          columnDisplay='ma_dtt'
          displayRelatedField='ten_dtt'
          value={params.row.ma_dtt_data?.ma_dtt || ''}
          onRowSelection={(row: DotThanhToan) => {
            onCellValueChange(params.row.uuid, 'ma_dtt_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_dtt',
        resultField: 'ma_dtt_data',
        detailEndpoint: QUERY_KEYS.DOT_THANH_TOAN
      }
    },
    {
      field: 'ma_ku',
      headerName: 'Khế ước',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<KheUoc>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.KHE_UOC}`}
          searchColumns={kheUocSearchColumns}
          dialogTitle='Danh mục khế ước'
          columnDisplay='ma_ku'
          displayRelatedField='ten_ku'
          value={params.row.ma_ku_data?.ma_ku || ''}
          onRowSelection={(row: KheUoc) => {
            onCellValueChange(params.row.uuid, 'ma_ku_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_ku',
        resultField: 'ma_ku_data',
        detailEndpoint: QUERY_KEYS.KHE_UOC
      }
    },
    {
      field: 'ma_phi',
      headerName: 'Phí',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<Phi>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.PHI}`}
          searchColumns={phiSearchColumns}
          dialogTitle='Danh mục phí'
          columnDisplay='ma_phi'
          displayRelatedField='ten_phi'
          value={params.row.ma_phi_data?.ma_phi || ''}
          onRowSelection={(row: Phi) => {
            onCellValueChange(params.row.uuid, 'ma_phi_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_phi',
        resultField: 'ma_phi_data',
        detailEndpoint: QUERY_KEYS.PHI
      }
    },
    {
      field: 'ma_sp',
      headerName: 'Sản phẩm',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<VatTu>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}`}
          searchColumns={vatTuSearchColumns}
          dialogTitle='Danh mục sản phẩm'
          columnDisplay='ma_vt'
          displayRelatedField='ten_vt'
          value={params.row.ma_sp_data?.ma_vt || ''}
          onRowSelection={(row: VatTu) => {
            onCellValueChange(params.row.uuid, 'ma_sp_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_sp',
        resultField: 'ma_sp_data',
        detailEndpoint: QUERY_KEYS.VAT_TU
      }
    },
    {
      field: 'ma_lsx',
      headerName: 'Lệnh sản xuất',
      width: 150,
      renderCell: (params: { row: any }) => (
        <SearchField<any>
          type='text'
          searchEndpoint={'/'}
          searchColumns={lenhSanXuatSearchColumns}
          dialogTitle='Danh mục lệnh sản xuất'
          columnDisplay='ma_lsx'
          displayRelatedField='ten_lsx'
          value={params.row.ma_lsx_data?.ma_lsx || params.row.ma_lsx || ''}
          onRowSelection={(row: LenhSanXuat) => {
            onCellValueChange(params.row.uuid, 'ma_lsx_data', row);
          }}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_lsx',
        resultField: 'ma_lsx_data',
        detailEndpoint: QUERY_KEYS.LENH_SAN_XUAT
      }
    },
    {
      field: 'ma_cp0',
      headerName: 'C/p không h/lệ',
      width: 180,
      renderCell: (params: { row: any }) => (
        <SearchField<ChiPhiKhongHopLeData>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.CHI_PHI_KHONG_HOP_LE}/`}
          searchColumns={chiPhiKhongHopLeSearchColumns}
          columnDisplay='ma_cp_khl'
          dialogTitle='Danh mục chi phí không hợp lệ'
          value={params.row.ma_cp0_data?.ma_cpkhl || ''}
          onRowSelection={(row: any) => onCellValueChange(params.row.uuid, 'ma_cp0_data', row)}
          disabled={formMode === 'view'}
          className='w-full'
        />
      ),
      pasteConfig: {
        lookupKey: 'ma_cp0',
        resultField: 'ma_cp0_data',
        detailEndpoint: QUERY_KEYS.CHI_PHI_KHONG_HOP_LE
      }
    }
  ];

  return baseColumns;
};
